import { AppLink, AppSpan, AppText, Circle, CustomContainer, FlexRow, GridContainer } from "src/style";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Dropdown } from "src/component";
import helpers from "./helpers";
import utility from "./utility";
import BankinglyLogo from 'src/assets/img/bankingly-logo-sm.svg'
import EbanqoLogo from 'src/assets/img/ebanqo-logo-sm.svg'
import QoreidLogo from 'src/assets/img/qoreid-logo-sm.svg'

export const categoriesColumns = (handleAction?: any) => [
    {
        name: 'Name of Category',
        selector:(row: any) => row.name,
        wrap: true,
        grow: 2
    },    
    {
        name: 'Category ID',
        selector:(row: any) => row.id,
        wrap: true,
        grow: 1
    },
    {
        name: 'Code',
        selector:(row: any) => row.code,
        wrap: true,
        grow: 1
    },
    {
        name: 'Availability Status',
        grow: 1,
        selector: (row: any) => {
            const status = row.availabilityStatus?.trim();
            const displayStatus = (!status || status.toLowerCase() === 'notavailable') 
                ? 'Not Available' 
                : status;
            const isAvailable = displayStatus === 'Available';
            
            return (
                <GridContainer 
                    width='auto' sizeUnit=""
                    minWidth='6.5' minHeight='2.5'
                    bgColor={isAvailable ? '#ECFDF3' : '#FEE4E2'} 
                    topPadding='0' bottomPadding='0' 
                    padding='0.8' radius='1.6'
                >
                    <AppSpan 
                        color={isAvailable ? '#027A48' : '#B42318'} 
                        fontWeight="500" textSize="1.2"
                    >
                        {displayStatus}
                    </AppSpan>
                </GridContainer>
            );
        },
    },
    {
        name: '',
        right: true,
        selector:(row: any) => 
        <Dropdown 
            trigger={<BsThreeDotsVertical fontSize='1.6rem' color='#111111' />}
            options={[
                {value: 'edit', label: 'Edit Category'}
            ]}
            onSelect={(value: string) => handleAction(row, value)}
            leftMargin={20}
            rightMargin={20}
        />
    }
]

export const categoriesData = [
    {
        categoryName: 'Platform & Administration',
        serviceId: '9036271',
        status: 'Active'
    },
    {
        categoryName: 'Chat bot',
        serviceId: '9036271',
        status: 'Inactive'
    },
    {
        categoryName: 'ID verification',
        serviceId: '9036271',
        status: 'Active'
    },
    {
        categoryName: 'Loan insurance',
        serviceId: '9036271',
        status: 'Active'
    },
]

export const sandboxUsersColumns = (handleAction?: any) => [
    {
        name: 'Full name',
        selector:(row: any) => row.fullName,
        wrap: true,
        grow: 2
    },
    {
        name: 'Email',
        selector:(row: any) => row.email,
        wrap: true,
        grow: 2
    },
    {
        name: 'Service Category',
        selector:(row: any) => row.serviceCategory,
        wrap: true,
        grow: 1
    },
    {
        name: 'Product ID',
        selector:(row: any) => row.productId,
        wrap: true,
        grow: 1
    },
    {
        name: 'Product name',
        selector:(row: any) => row.productName,
        wrap: true,
        grow: 1
    },
    {
        name: '',
        right: true,
        selector:(row: any) => 
        <Dropdown 
            trigger={<BsThreeDotsVertical fontSize='1.6rem' color='#111111' />}
            options={[
                {value: 'edit', label: 'Edit sandbox user'},
                {value: 'disable', label: 'Disable sandbox user'}
            ]}
            onSelect={(value: string) => handleAction(row, value)}
            leftMargin={20}
            rightMargin={20}
        />
    }
]

export const sandboxUsersData = [
    {
        fullName: 'Ridwan Kolawole',
        email: 'rkolawole@appzonegroup.com',
        serviceCategory: 'Insurance',
        productId: '9067430',
        productName: 'Qoreid',
        role: 'Admin',
        phoneNumber: '+2347023456791'
    },
    {
        fullName: 'Iyin Laditan',
        email: 'iyin@gmail.com',
        serviceCategory: 'Payment',
        productId: '9067430',
        productName: 'Qoreid',
        role: 'Admin',
        phoneNumber: '+2347023456791'
    },
    {
        fullName: 'Ridwan Kolawole',
        email: 'rkolawole@appzonegroup.com',
        serviceCategory: 'Insurance',
        productId: '9067430',
        productName: 'Qoreid',
        role: 'Admin',
        phoneNumber: '+2347023456791'
    },
    {
        fullName: 'Iyin Laditan',
        email: 'iyin@gmail.com',
        serviceCategory: 'Payment',
        productId: '9067430',
        productName: 'Qoreid',
        role: 'Admin',
        phoneNumber: '+2347023456791'
    }
]


export const usersColumns = (handleView: any) => [
    {
        name: 'Username',
        selector:(row: any) => row.userName,
        wrap: true,
        width: '17rem'
    },
    {
        name: 'Full name',
        selector: (row: any) => `${row.firstName || ''} ${row.lastName || ''}`.trim(),
        wrap: true,
        width: '27rem'
    },
    {
        name: 'Email',
        selector:(row: any) => row.email,
        wrap: true,
        width: '20rem'
    },
    {
        name: 'Phone number',
        selector:(row: any) => row.phoneNumber,
        wrap: true,
        width: '15rem'
    },
    {
        name: 'Status',
        width: '15rem',
        selector:(row: any) => (
            <GridContainer 
                width='auto' sizeUnit=""
                minWidth = '6.5' minHeight='2.5'
                bgColor={row.status === 'Active' ? '#ECFDF3' : '#FEE4E2'} 
                topPadding='0' bottomPadding='0' 
                padding='0.8' radius='1.6'
            >
                <AppSpan 
                    color={row.status === 'Active' ? '#027A48' : '#B42318'} 
                    fontWeight="500" textSize="1.2"
                >
                    {row.status}
                </AppSpan>
            </GridContainer>
        ),
    },
    {
        name: '',
        right: true,
        minWidth: '12rem',
        selector:(row: any) => 
            <AppSpan 
                color="#027A48"
                hoverColor="#667085"
                fontWeight="500"
                cursor="pointer"
                onClick={() => handleView(row)}
            >
                View Details
            </AppSpan>
    },
]

export const usersData = [
    {
        username: 'Rhydhur',
        fullName: 'Ridwan Kolawole',
        email: 'rkolawole@appzonegroup.com',
        phoneNumber: '08156271829',
        status: 'Active'
    },
    {
        username: 'Elnino',
        fullName: 'John Doe',
        email: 'rkolawole@appzonegroup.com',
        phoneNumber: '08156271829',
        status: 'Inactive'
    },
    {
        username: 'JBoy',
        fullName: 'John Doe',
        email: 'rkolawole@appzonegroup.com',
        phoneNumber: '08156271829',
        status: 'Active'
    },
    {
        username: 'Rhydhur',
        fullName: 'Ridwan Kolawole',
        email: 'rkolawole@appzonegroup.com',
        phoneNumber: '08156271829',
        status: 'Active'
    },
]


export const feesColumns = (handleAction?: any) => {
    const columns = [
        {
            name: 'Fee ID',
            selector:(row: any) => row.id,
            wrap: true,
            //grow: 2
        },
        {
            name: 'Name of Fee',
            selector:(row: any) => row.name,
            wrap: true,
            minWidth: '15rem',
            //grow: 2
        },
        {
            name: 'Lower bound',
            selector:(row: any) => row.lowerBound,
            wrap: true,
            minWidth: '15rem',
            //grow: 1
        },
        {
            name: 'Upper bound',
            selector:(row: any) => row.upperBound,
            wrap: true,
            minWidth: '15rem',
            //grow: 1
        },
        {
            name: 'Fixed Charge',
            selector:(row: any) => row.fixedFee,
            wrap: true,
            minWidth: '15rem',
            //grow: 1
        },
        {
            name: 'Percentage Charge',
            selector:(row: any) => <AppSpan>{row.percentageFee}%</AppSpan>,
            wrap: true,
            minWidth: '17rem',
            //grow: 1
        },
        {
            name: 'Minimum % Charge',
            selector:(row: any) => <AppSpan>{row.minimumFee}</AppSpan>,
            wrap: true,
            minWidth: '17rem',
            //grow: 1
        },
        {
            name: 'Maximum % Charge',
            selector:(row: any) => <AppSpan>{row.maximumFee}</AppSpan>,
            wrap: true,
            minWidth: '17rem',
            //grow: 1
        }
    ]

    const optionalObj: any = {
        name: '',
        right: true,
        selector:(row: any) => 
        <Dropdown 
            trigger={<BsThreeDotsVertical fontSize='1.6rem' color='#111111' />}
            options={[
                {value: 'edit', label: 'Edit Fee'},
                {value: 'delete', label: 'Delete Fee'}
            ]}
            onSelect={(value: string) => handleAction(row, value)}
        />
    }

    if (handleAction) {
        columns.push(optionalObj)
    }

    return columns
}

export const feesData = [
    {
        feeId: '001',
        feeName: 'Platform',
        lowerBound: 3500000,
        upperBound: 3500000,
        fixedFee: 3500000,
        percentageCharge: 90,
        minimumPercentCharge: 30,
        maximumPercentCharge: 30,
        qoreFee: 20, 
        serviceProviderFee: 35
    },
    {
        feeId: '002',
        feeName: 'Chatbot',
        lowerBound: 3500000,
        upperBound: 3500000,
        fixedCharge: 3500000,
        percentageCharge: 90,
        minimumPercentCharge: 30,
        maximumPercentCharge: 30,
        qoreFee: 20, 
        serviceProviderFee: 35
    },
    {
        feeId: '003',
        feeName: 'ID verification',
        lowerBound: 3500000,
        upperBound: 3500000,
        fixedCharge: 3500000,
        percentageCharge: 90,
        minimumPercentCharge: 30,
        maximumPercentCharge: 30,
        qoreFee: 20, 
        serviceProviderFee: 35
    },
    {
        feeId: '004',
        feeName: 'Loan insurance',
        lowerBound: 3500000,
        upperBound: 3500000,
        fixedCharge: 3500000,
        percentageCharge: 90,
        minimumPercentCharge: 30,
        maximumPercentCharge: 30,
        qoreFee: 20, 
        serviceProviderFee: 35
    }
]

export const customerFeeData = [
    {
        feeId: '001',
        feeName: 'Platform',
        lowerBound: 3500000,
        upperBound: 3500000,
        fixedCharge: 3500000,
        percentageCharge: 90,
        minimumPercentCharge: 30,
        maximumPercentCharge: 30
    }
]

export const serviceProviderFeeData = [
    {
        feeId: '001',
        feeName: 'Platform',
        lowerBound: 3500000,
        upperBound: 3500000,
        fixedCharge: 3500000,
        percentageCharge: 90,
        minimumPercentCharge: 30,
        maximumPercentCharge: 30
    },
    {
        feeId: '002',
        feeName: 'Chatbot',
        lowerBound: 3500000,
        upperBound: 3500000,
        fixedCharge: 3500000,
        percentageCharge: 90,
        minimumPercentCharge: 30,
        maximumPercentCharge: 30
    },
]


export const productServicesColumns = (handleAction?: any) => [
    {
        name: 'Service Name',
        selector:(row: any) => row.name,
        wrap: true,
        grow: 1
    },
    {
        name: '',
        right: true,
        selector:(row: any) => 
        <Dropdown 
            trigger={<BsThreeDotsVertical fontSize='1.6rem' color='#667085' />}
            options={[
                {value: 'assign', label: 'Assign Fees'},
                {value: 'modify', label: 'Modify Fees'},
                {value: row.status === 'Active' ? 'disable' : 'enable', label: `${row.status === 'Active' ? 'Disable' : 'Enable'} Fees`},
                {value: 'delete', label: 'Delete Fees'}
            ]}
            onSelect={(value: string) => handleAction(row, value)}
            width={22.7}
            rightMargin={60}
        />
    }
]

export const productServicesData = [
    {
        id: 1,
        serviceName: 'NIN Facematch'
    },
    {
        id: 2,
        serviceName: 'BVN Facematch'
    },
    {
        id: 3,
        serviceName: 'ID Verification'
    },
    {
        id: 4,
        serviceName: 'Loan Insurance'
    }
]

export const productBillingSetupColumns = (handleAction?: any) => [
    {
        name: 'Fee Type',
        selector:(row: any) => row.feeType,
        wrap: true,
        grow: 1
    },
    {
        name: '',
        right: true,
        selector:(row: any) => 
        <Dropdown 
            trigger={<BsThreeDotsVertical fontSize='1.6rem' color='#667085' />}
            options={[
                {value: 'assign', label: 'Assign Fees'},
                {value: 'modify', label: 'Modify Fees'},
                {value: 'delete', label: 'Delete Fees'}
            ]}
            onSelect={(value: string) => handleAction(row, value)}
        />
    }
]

export const productBillingSetupData = [
    {
        id: 1,
        feeType: 'Flat monthly Fee'
    },
    {
        id: 2,
        feeType: 'Active Bank Staff User Fee'
    },
    {
        id: 3,
        feeType: 'Active Bank Customer Fee'
    },
    {
        id: 4,
        feeType: 'Enrolled Bank Staff User Fee'
    }
]

export const auditColumns = [
    {
        name: 'User performing action',
        selector:(row: any) => row.fullName,
        wrap: true,
        grow: 2
    },
    {
        name: 'Action performed',
        selector:(row: any) => row.actionPerformed,
        wrap: true,
        grow: 2
    },
    {
        name: 'Output of process',
        selector:(row: any) => row.outputOfprocess,
        wrap: true,
        grow: 2
    },
    {
        name: 'Date and time of activity',
        selector:(row: any) => row.createdAt ? helpers.splitDateTime(row.createdAt)?.completeDateTime : null,
        wrap: true,
        grow: 2
    }
]

export const auditData = [
    {
        fullName: 'Ridwan Kolawole',
        actionPerformed: 'Null',
        outputOfprocess: 'Null',
        createdAt: '2024-08-27T08:26:33.569Z'
    },
    {
        fullName: 'Ridwan Kolawole',
        actionPerformed: 'Null',
        outputOfprocess: 'Null',
        createdAt: '2024-08-27T08:26:33.569Z'
    },
    {
        fullName: 'Ridwan Kolawole',
        actionPerformed: 'Null',
        outputOfprocess: 'Null',
        createdAt: '2024-08-27T08:26:33.569Z'
    },
    {
        fullName: 'Ridwan Kolawole',
        actionPerformed: 'Null',
        outputOfprocess: 'Null',
        createdAt: '2024-08-27T08:26:33.569Z'
    }
]


export const categoriesReportColumns = [
    {
        name: 'Categories',
        selector:(row: any) => row.category,
        wrap: true,
        grow: 1
    },
    {
        name: 'Service type',
        selector:(row: any) => row.serviceType,
        wrap: true,
        grow: 1
    },
    {
        name: 'Service type ID',
        selector:(row: any) => row.serviceTypeId,
        wrap: true,
        grow: 1
    },
    {
        name: 'Additional info.',
        selector:(row: any) => row.additionalInfo,
        wrap: true,
        grow: 2
    }
]

export const categoriesReportData = [
    {
        category: 'Payment',
        serviceType: 'Zapier',
        serviceTypeId: '678962ED',
        additionalInfo: 'Lorem ipsum dolor sit amet, consectetur adipiscing'
    },
    {
        category: 'Digital banking',
        serviceType: 'Zapier',
        serviceTypeId: '678962ED',
        additionalInfo: 'Lorem ipsum dolor sit amet, consectetur adipiscing'
    },
    {
        category: 'Insurance',
        serviceType: 'Zapier',
        serviceTypeId: '678962ED',
        additionalInfo: 'Lorem ipsum dolor sit amet, consectetur adipiscing'
    },
    {
        category: 'Payment',
        serviceType: 'Zapier',
        serviceTypeId: '678962ED',
        additionalInfo: 'Lorem ipsum dolor sit amet, consectetur adipiscing'
    }
]

export const serviceProviderReportColumns = [
    {
        name: 'Service name',
        selector:(row: any) => row.serviceName,
        wrap: true,
        grow: 1
    },
    {
        name: 'Service type',
        selector:(row: any) => row.serviceType,
        wrap: true,
        grow: 1
    },
    {
        name: 'No. of Banks',
        selector:(row: any) => row.noOfBanks,
        wrap: true,
        grow: 1
    },
    {
        name: 'Installed for',
        selector:(row: any) => row.installedFor,
        wrap: true,
        grow: 2
    },
    {
        name: 'Service setup fee',
        selector:(row: any) => ` ₦${utility.moneyFormat(row.setupFee || 0)}`,
        wrap: true,
        grow: 1
    },
    {
        name: 'Setup fee Percentage',
        selector:(row: any) => `${row.setupFeePercent}%`,
        wrap: true,
        grow: 1
    },
]

export const serviceProviderReportData = [
    {
        serviceName: 'Payment',
        serviceType: 'Zapier',
        noOfBanks: '6',
        installedFor: 'Lorem ipsum dolor sit amet, consectetur adipiscing',
        setupFee: '400000',
        setupFeePercent: 90
    },
    {
        serviceName: 'Digital banking',
        serviceType: 'Zapier',
        noOfBanks: '6',
        installedFor: 'Lorem ipsum dolor sit amet, consectetur adipiscing',
        setupFee: '400000',
        setupFeePercent: 90
    },
    {
        serviceName: 'Payment',
        serviceType: 'Zapier',
        noOfBanks: '6',
        installedFor: 'Lorem ipsum dolor sit amet, consectetur adipiscing',
        setupFee: '400000',
        setupFeePercent: 90
    },
    {
        serviceName: 'Payment',
        serviceType: 'Zapier',
        noOfBanks: '6',
        installedFor: 'Lorem ipsum dolor sit amet, consectetur adipiscing',
        setupFee: '400000',
        setupFeePercent: 90
    },
]

export const serviceProvidersColumns = (handleAction?: any) => [
    {
        name: 'Service provider name',
        selector:(row: any) => 
            <FlexRow gap='1'>
                <Circle 
                    size="5" bgColor='#ffffff' 
                    borderColor='#EAECF0'
                    className='fixed-flex-shape'
                    style={{overflow: 'hidden'}}
                >
                    <Circle 
                        size='4'
                        style={{overflow: 'hidden'}}
                    >
                        <img 
                            src={row.logoUrl} 
                            className='img-covered' 
                            style={{objectFit: 'contain'}} 
                        />
                    </Circle>
                </Circle>
                <AppSpan 
                    color='#667085' textSize='1.4' fontWeight="500"
                >
                    {row.companyName}
                </AppSpan>
            </FlexRow>,
        wrap: true,
        grow: 3
    },
    {
        name: 'Service provider Code',
        selector:(row: any) => row.code,
        wrap: true,
        grow: 2
    },
    {
        name: 'Date of creation',
        selector:(row: any) => row.dateCreated ? helpers.splitDateTime(row.dateCreated)?.completeDateTime : null,
        wrap: true,
        grow: 2
    },
    {
        name: 'Service provider ID',
        selector:(row: any) => row.id,
        wrap: true,
        grow: 2
    },
    {
        name: 'Status',
        grow: 2,
        selector:(row: any) => (
            <GridContainer 
                width='auto' sizeUnit=""
                minWidth = '6.5' minHeight='2.5'
                bgColor={row.status === 'Active' ? '#ECFDF3' : '#FEE4E2'} 
                topPadding='0' bottomPadding='0' 
                padding='0.8' radius='1.6'
            >
                <AppSpan 
                    color={row.status === 'Active' ? '#027A48' : '#B42318'} 
                    fontWeight="500" textSize="1.2"
                >
                    {row.status}
                </AppSpan>
            </GridContainer>
        ),
    },
    {
        name: '',
        right: true,
        selector:(row: any) => 
        <Dropdown 
            trigger={<BsThreeDotsVertical fontSize='1.6rem' color='#111111' />}
            options={[
                {value: 'view', label: 'View Details'},
                {value: `${row.status === 'Active' ? 'deactivate' : 'activate'}`, label: `${row.status === 'Active' ? 'Deactivate' : 'Activate'} Service Provider`}
            ]}
            onSelect={(value: string) => handleAction(row, value)}
            rightMargin={60}
            width={23}
        />
    }
]

export const serviceProvidersData = [
    {
        name: 'Qoreid',
        logo: QoreidLogo,
        createdAt: '2024-08-27T08:26:33.569Z',
        serviceCategory: 'Insurance',
        serviceProviderId: '9033627',
        status: 'Active',
        adminFirstName: 'John',
        adminLastName: 'Doe',
        adminEmail: 'example@gmail.com',
        adminPhoneNumber: '07036172919',
    },
    {
        name: 'eBanqo',
        logo: EbanqoLogo,
        createdAt: '2024-08-27T08:26:33.569Z',
        serviceCategory: 'Payment',
        serviceProviderId: '9033627',
        status: 'Inactive',
        adminFirstName: 'John',
        adminLastName: 'Doe',
        adminEmail: 'example@gmail.com',
        adminPhoneNumber: '07036172919',
    },
    {
        name: 'Bankingly',
        logo: BankinglyLogo,
        createdAt: '2024-08-27T08:26:33.569Z',
        serviceCategory: 'Digital Banking',
        serviceProviderId: '9033627',
        status: 'Active',
        adminFirstName: 'John',
        adminLastName: 'Doe',
        adminEmail: 'example@gmail.com',
        adminPhoneNumber: '07036172919',
    },
    {
        name: 'eBanqo',
        logo: EbanqoLogo,
        createdAt: '2024-08-27T08:26:33.569Z',
        serviceCategory: 'Payment',
        serviceProviderId: '9033627',
        status: 'Active',
        adminFirstName: 'John',
        adminLastName: 'Doe',
        adminEmail: 'example@gmail.com',
        adminPhoneNumber: '07036172919',
    },
]

export const tagsColumns = (handleAction?: any) => [
    {
        name: 'Tag Name',
        selector:(row: any) => row.tagName,
        wrap: true,
        grow: 2
    },
    {
        name: 'Tag ID',
        selector:(row: any) => row.tagId,
        wrap: true,
        grow: 1
    },
    {
        name: 'Status',
        grow: 1,
        selector:(row: any) => (
            <GridContainer 
                width='auto' sizeUnit=""
                minWidth = '6.5' minHeight='2.5'
                bgColor={row.status === 'Active' ? '#ECFDF3' : '#FEE4E2'} 
                topPadding='0' bottomPadding='0' 
                padding='0.8' radius='1.6'
            >
                <AppSpan 
                    color={row.status === 'Active' ? '#027A48' : '#B42318'} 
                    fontWeight="500" textSize="1.2"
                >
                    {row.status}
                </AppSpan>
            </GridContainer>
        ),
    },
    {
        name: '',
        right: true,
        selector:(row: any) => 
        <Dropdown 
            trigger={<BsThreeDotsVertical fontSize='1.6rem' color='#111111' />}
            options={[
                {value: 'edit', label: 'Edit Tag'},
                {value: 'disable', label: 'Disable tag'}
            ]}
            onSelect={(value: string) => handleAction(row, value)}
            leftMargin={20}
            rightMargin={20}
        />
    }
]

export const tagsData = [
    {
        tagName: 'Platform & Adminstration',
        tagId: '9067430',
        status: 'Active'
    },
    {
        tagName: 'Chat bot',
        tagId: '9067430',
        status: 'Inactive'
    },
    {
        tagName: 'ID verification',
        tagId: '9067430',
        status: 'Active'
    },
    {
        tagName: 'Loan insurance',
        tagId: '9067430',
        status: 'Active'
    }
]


export const outboundApiCallsColumns = (handleAction?: any) => [
    {
        name: 'Product',
        selector:(row: any) => row.productName,
        wrap: true,
        grow: 2,
        minWidth: '20rem'
    },
    {
        name: 'Service code',
        selector:(row: any) => row.serviceCode,
        wrap: true,
        grow: 2,
        minWidth: '18rem'
    },
    {
        name: 'Call time',
        selector:(row: any) => row.callTime,
        wrap: true,
    },
    {
        name: 'Duration',
        selector:(row: any) => row.duration,
        wrap: true,
    },
    {
        name: 'Status',
        minWidth: '18rem',
        selector:(row: any) => (
            <GridContainer 
                width='auto' sizeUnit=""
                minWidth = '6.5' minHeight='2.5'
                bgColor={row.responseStatus === 'Successful' ? '#ECFDF3' : '#FEE4E2'} 
                topPadding='0' bottomPadding='0' 
                padding='0.8' radius='1.6'
            >
                <AppSpan 
                    color={row.responseStatus === 'Successful' ? '#027A48' : '#B42318'} 
                    fontWeight="500" textSize="1.2"
                >
                    {row.responseStatus}
                </AppSpan>
            </GridContainer>
        ),
    },
    {
        name: 'Response code',
        selector:(row: any) => row.responseCode,
        wrap: true,
        minWidth: '17rem'
    },
    {
        name: 'Response message',
        selector:(row: any) => row.responseMessage,
        wrap: true,
        minWidth: '22rem'
    },
    {
        name: 'Date',
        selector:(row: any) => row.dateCreated ? helpers.splitDateTime(row.dateCreated)?.slashedDate : null,
        wrap: true,
    },
    {
        name: '',
        right: true,
        width: '15rem',
        selector:(row: any) => 
        <AppSpan
            fontWeight="500"
            color="#0A756F" 
            cursor="pointer"
            hoverColor="#667085"
            onClick={() => handleAction(row)}
        >
            View Details
        </AppSpan>
    }
]

export const outboundApiCallsData = [
    {
        productName: 'QoreId',
        serviceCode: '5673',
        callTime: '07:14',
        duration: '20 mins',
        responseStatus: 'Successful',
        responseCode: '200',
        responseMessage: "Request Successful",
        dateCreated: '2024-08-27T08:26:33.569Z'
    },
    {
        productName: 'QoreId',
        serviceCode: '5673',
        callTime: '07:14',
        duration: '20 mins',
        responseStatus: 'Successful',
        responseCode: '200',
        responseMessage: "Request Successful",
        dateCreated: '2024-08-27T08:26:33.569Z'
    },
    {
        productName: 'QoreId',
        serviceCode: '5673',
        callTime: '07:14',
        duration: '20 mins',
        responseStatus: 'Successful',
        responseCode: '200',
        responseMessage: "Request Successful",
        dateCreated: '2024-08-27T08:26:33.569Z'
    },
    {
        productName: 'QoreId',
        serviceCode: '5673',
        callTime: '07:14',
        duration: '20 mins',
        responseStatus: 'Failed',
        responseCode: '200',
        responseMessage: "Request Successful",
        dateCreated: '2024-08-27T08:26:33.569Z'
    }
] 

export const inboundApiCallsColumns = (handleAction?: any) => [
    {
        name: 'Product',
        selector:(row: any) => row.productName,
        wrap: true,
        grow: 1
    },
    {
        name: 'Time received',
        selector:(row: any) => row.timeReceived,
        wrap: true,
        grow: 1
    },
    {
        name: 'Response status',
        grow: 1,
        selector:(row: any) => (
            <GridContainer 
                width='auto' sizeUnit=""
                minWidth = '6.5' minHeight='2.5'
                bgColor={row.responseStatus === 'Successful' ? '#ECFDF3' : '#FEE4E2'} 
                topPadding='0' bottomPadding='0' 
                padding='0.8' radius='1.6'
            >
                <AppSpan 
                    color={row.responseStatus === 'Successful' ? '#027A48' : '#B42318'} 
                    fontWeight="500" textSize="1.2"
                >
                    {row.responseStatus}
                </AppSpan>
            </GridContainer>
        ),
    },
    {
        name: 'Date',
        selector:(row: any) => row.dateCreated ? helpers.splitDateTime(row.dateCreated)?.slashedDate : null,
        wrap: true,
        grow: 1
    },
    {
        name: '',
        right: true,
        selector:(row: any) => 
        <AppSpan
            fontWeight="500"
            color="#0A756F" 
            cursor="pointer"
            hoverColor="#667085"
            onClick={() => handleAction(row)}
        >
            View Details
        </AppSpan>
    }
]

export const inboundApiCallsData = [
    {
        productName: 'QoreId',
        timeReceived: '07:14',
        responseStatus: 'Successful',
        dateCreated: '2024-08-27T08:26:33.569Z'
    },
    {
        productName: 'QoreId',
        timeReceived: '07:14',
        responseStatus: 'Successful',
        dateCreated: '2024-08-27T08:26:33.569Z'
    },
    {
        productName: 'QoreId',
        timeReceived: '07:14',
        responseStatus: 'Successful',
        dateCreated: '2024-08-27T08:26:33.569Z'
    },
    {
        productName: 'QoreId',
        timeReceived: '07:14',
        responseStatus: 'Failed',
        dateCreated: '2024-08-27T08:26:33.569Z'
    },
]


export const categoriesSettingColumns = (handleAction?: any) => [
    {
        name: 'Name of Category',
        selector:(row: any) => row.name,
        wrap: true,
        grow: 1
    },
    {
        name: 'Service Category ID',
        selector:(row: any) => row.id,
        wrap: true,
        grow: 1
    },
    {
        name: 'Description',
        selector:(row: any) => `${row.description?.substring(0, 50)}${row.description?.length > 50 ? '...': ''}`,
        wrap: true,
        grow: 2
    },
    {
        name: 'Status',
        grow: 1,
        selector:(row: any) => (
            <GridContainer 
                width='auto' sizeUnit=""
                minWidth = '6.5' minHeight='2.5'
                bgColor={row.status === 'Active' ? '#ECFDF3' : '#FEE4E2'} 
                topPadding='0' bottomPadding='0' 
                padding='0.8' radius='1.6'
            >
                <AppSpan 
                    color={row.status === 'Active' ? '#027A48' : '#B42318'} 
                    fontWeight="500" textSize="1.2"
                >
                    {row.status}
                </AppSpan>
            </GridContainer>
        ),
    },
    {
        name: '',
        right: true,
        selector: (row: any) => {
            const isActive = row.status === 'Active'
            const newStatus = isActive ? "DeactivateCategory" : "ActivateCategory"
            const label = isActive ? 'Deactivate' : 'Activate'
    
            return (
                <AppSpan
                    fontWeight="500"
                    color="#0A756F"
                    cursor="pointer"
                    hoverColor="#667085"
                    onClick={() => handleAction(row.id, newStatus)}
                >
                    {label}
                </AppSpan>
            )
        }
    }
]

export const categoriesSettingData = [
    {
        categoryName: 'Platform & Administration',
        serviceId: '906478',
        paymentType: 'Prepaid',
        status: 'Active'
    },
    {
        categoryName: 'Chat bot',
        serviceId: '906478',
        paymentType: 'postaid',
        status: 'Inactive'
    },
    {
        categoryName: 'ID Verification',
        serviceId: '906478',
        paymentType: 'Prepaid',
        status: 'Active'
    },
    {
        categoryName: 'Loan insurance',
        serviceId: '906478',
        paymentType: 'postaid',
        status: 'Inactive'
    }
]

export const productsSettingColumns = (handleAction?: any) => [
    {
        name: 'Product',
        selector:(row: any) => 
            <FlexRow gap='1'>
                <Circle 
                    size="5" bgColor='#ffffff' 
                    borderColor='#EAECF0'
                    className='fixed-flex-shape'
                    style={{overflow: 'hidden'}}
                >
                    <Circle 
                        size='4'
                        style={{overflow: 'hidden'}}
                    >
                        <img 
                            src={row.product.logoUrl} 
                            className='img-covered' 
                            style={{objectFit: 'contain'}} 
                        />
                    </Circle>
                </Circle>
                <AppSpan 
                    color='#667085' textSize='1.4' fontWeight="500"
                >
                    {row.product.name}
                </AppSpan>
            </FlexRow>,
        wrap: true,
        grow: 5
    },
    {
        name: 'Product website url',
        selector:(row: any) => <AppLink href={row.product.websiteUrl}>{row.product.websiteUrl}</AppLink>,
        wrap: true,
        grow: 2
    },
    {
        name: 'Product ID',
        selector:(row: any) => row.product.id,
        wrap: true,
        grow: 2
    },
    {
        name: 'Terms & Conditions',
        selector:(row: any) => row.product.termsAndConditions,
        wrap: true,
        grow: 2
    },
    {
        name: 'Category ID',
        selector:(row: any) => row.product.serviceCategoryId,
        wrap: true,
        grow: 2
    },
    {
        name: 'Status',
        grow: 2,
        selector:(row: any) => (
            <GridContainer 
                width='auto' sizeUnit=""
                minWidth = '6.5' minHeight='2.5'
                bgColor={row.status === 'Active' ? '#ECFDF3' : '#FEE4E2'} 
                topPadding='0' bottomPadding='0' 
                padding='0.8' radius='1.6'
            >
                <AppSpan 
                    color={row.status === 'Active' ? '#027A48' : '#B42318'} 
                    fontWeight="500" textSize="1.2"
                >
                    {row.status}
                </AppSpan>
            </GridContainer>
        ),
    },
    {
        name: '',
        right: true,
        selector:(row: any) => 
        <Dropdown 
            trigger={<BsThreeDotsVertical fontSize='1.6rem' color='#111111' />}
            options={[
                {value: 'view', label: 'View Product'},
                {value: `${row.status === 'Active' ? 'deactivate' : 'activate'}`, label: `${row.status === 'Active' ? 'Deactivate' : 'Activate'} Product`}
            ]}
            onSelect={(value: string) => handleAction(row, value)}
            rightMargin={60}
            width={23}
        />
    }
]

export const productsSettingData = [
    {
        productName: 'Qoreid',
        logoUrl: QoreidLogo,
        websiteUrl: 'www.qoreid.com',
        category: 'Insurance',
        productId: '9033627',
        contact: '09027890879',
        status: 'Active'
    },
    {
        productName: 'eBanqo',
        logoUrl: EbanqoLogo,
        websiteUrl: 'www.qoreid.com',
        category: 'Payment',
        productId: '9033627',
        contact: '09027890879',
        status: 'Inactive'
    },
    {
        productName: 'Bankingly',
        logoUrl: BankinglyLogo,
        websiteUrl: 'www.qoreid.com',
        category: 'Digital Banking',
        productId: '9033627',
        contact: '09027890879',
        status: 'Active'
    },
    {
        productName: 'eBanqo',
        logoUrl: EbanqoLogo,
        websiteUrl: 'www.qoreid.com',
        category: 'Payment',
        productId: '9033627',
        contact: '09027890879',
        status: 'Active'
    },
]

export const walletFundingHistoryColumns = [
    {
        name: 'Transaction type',
        selector:(row: any) => row.transactionType,
        wrap: true
    },
    {
        name: 'Date of creation',
        selector:(row: any) => row.dateCreated ? helpers.splitDateTime(row.dateCreated)?.slashedDate : null,
        wrap: true
    },
    {
        name: 'Amount',
        selector:(row: any) => <AppSpan color="#409809">+ N{utility.koboFormat(row.amount || 0)}</AppSpan>,
        wrap: true
    }
]

export const walletFundingHistoryData = [
    {
        transactionType: 'Card Transaction',
        dateCreated: '2024-08-27T08:26:33.569Z',
        amount: 244000
    },
    {
        transactionType: 'Bank Transaction',
        dateCreated: '2024-08-27T08:26:33.569Z',
        amount: 244000
    },
    {
        transactionType: 'Card Transaction',
        dateCreated: '2024-08-27T08:26:33.569Z',
        amount: 244000
    },
    {
        transactionType: 'Bank Transaction',
        dateCreated: '2024-08-27T08:26:33.569Z',
        amount: 244000
    }
]


export const billingHistoryColumns = (handleAction?: any) => [
    {
        name: 'S/N',
        selector:(row: any) => row.sn,
        wrap: true,
        grow: 1
    },
    {
        name: 'Service Provider',
        selector:(row: any) => 
            <FlexRow gap='1'>
                <Circle 
                    size="5" bgColor='#ffffff' 
                    borderColor='#EAECF0'
                    className='fixed-flex-shape'
                    style={{overflow: 'hidden'}}
                >
                    <Circle 
                        size='4'
                        style={{overflow: 'hidden'}}
                    >
                        <img 
                            src={row.serviceProviderLogo} 
                            className='img-covered' 
                            style={{objectFit: 'contain'}} 
                        />
                    </Circle>
                </Circle>
                <AppSpan 
                    color='#667085' textSize='1.4' fontWeight="500"
                >
                    {row.serviceProviderName}
                </AppSpan>
            </FlexRow>,
        wrap: true,
        grow: 4,
        minWidth: '30rem'
    },
    {
        name: 'Bill Type',
        selector:(row: any) => row.billingType,
        wrap: true,
        grow: 2,
        minWidth: '15rem'
    },
    {
        name: 'Date / Period',
        selector:(row: any) => row.dateCreated ? helpers.splitDateTime(row.dateCreated)?.completeDateTime : null,
        wrap: true,
        grow: 3,
        minWidth: '18rem'
    },
    {
        name: 'Amount',
        selector:(row: any) => <AppSpan>N{utility.koboFormat((row.fee || 0) * 100)}</AppSpan>,
        wrap: true,
        grow: 2,
        minWidth: '15rem'
    },
    {
        name: 'Debit Source',
        selector:(row: any) => row.debitSource,
        wrap: true,
        grow: 2
    },
    // {
    //     name: '',
    //     right: true,
    //     grow: 2,
    //     selector:(row: any) => 
    //     <AppSpan
    //         fontWeight="500"
    //         color="#0A756F" 
    //         cursor="pointer"
    //         hoverColor="#667085"
    //         onClick={() => handleAction(row)}
    //     >
    //         View Details
    //     </AppSpan>
    // }
]

export const billingHistoryData = [
    {
        providerName: 'Qoreid',
        logoUrl: QoreidLogo,
        billingName: 'BVN Facematch Verification',
        dateCreated: '2024-08-27T08:26:33.569Z',
        amount: 180,
        debitSource: 'Wallet',
        numberOfServices: 3
    },
    {
        providerName: 'eBanqo',
        logoUrl: EbanqoLogo,
        billingName: 'February 2023 Billing Report',
        dateCreated: '2024-08-27T08:26:33.569Z',
        amount: 10000,
        debitSource: 'Expense GL',
        numberOfServices: 3
    },
    {
        providerName: 'Bankingly',
        logoUrl: BankinglyLogo,
        billingName: 'January 2023 Biling Report',
        dateCreated: '2024-08-27T08:26:33.569Z',
        amount: 70000,
        debitSource: 'Wallet',
        numberOfServices: 3
    },
    {
        providerName: 'eBanqo',
        logoUrl: EbanqoLogo,
        billingName: 'March 2023 Biling Report',
        dateCreated: '2024-08-27T08:26:33.569Z',
        amount: 25000,
        debitSource: 'Expense GL',
        numberOfServices: 3
    }
]

export const billingDetailsServiceColumns = [
    {
        name: 'S/N',
        selector:(row: any) => row.sn,
        wrap: true,
        width: '8rem'
    },
    {
        name: 'Service',
        selector:(row: any) => row.serviceName,
        wrap: true
    },
    {
        name: 'Product',
        selector:(row: any) => row.productName,
        wrap: true
    },
    {
        name: 'Charges',
        selector:(row: any) => `N${utility.koboFormat(row.charges || 0)}`,
        wrap: true
    }
]

export const billingDetailsServiceData = [
    {
        serviceName: 'Intra Bank Service',
        productName: 'Recova',
        charges: '110200'
    },
    {
        serviceName: 'Balance Enquiry Service',
        productName: 'Crendly',
        charges: '110200'
    },
    {
        serviceName: 'Name Bank Service',
        productName: 'Prime',
        charges: '110200'
    }
]

